import { render, staticRenderFns } from "./LicenseDetailModal.vue?vue&type=template&id=38abdcbe&"
import script from "./LicenseDetailModal.vue?vue&type=script&lang=js&"
export * from "./LicenseDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./LicenseDetailModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports